/** Grouping the profile screens share.
 *
 * Both the member's own identification page and the training-group screen an
 * administrator corrects a participant's profile on show these lists under
 * their category and group headings, exactly as the Django templates do. They
 * live here rather than in `ProfileFields.tsx` because a component file that
 * also exports helpers loses fast refresh.
 */
import type { Characteristic, Sector } from "../types";

/** Group characteristics under their main-characteristic heading, preserving
 * input order (the API already orders them by group then position). */
export function groupCharacteristics(
  characteristics: Characteristic[],
  t: (key: string) => string,
): { group: string; items: Characteristic[] }[] {
  const order: string[] = [];
  const map = new Map<string, Characteristic[]>();
  for (const characteristic of characteristics) {
    const group =
      characteristic.group?.name ??
      t("questionnaire.identification.otherCharacteristics");
    if (!map.has(group)) {
      map.set(group, []);
      order.push(group);
    }
    map.get(group)!.push(characteristic);
  }
  return order.map((group) => ({ group, items: map.get(group)! }));
}

/** Group sectors under their category name, preserving input order. */
export function groupByCategory(
  sectors: Sector[],
  t: (key: string) => string,
): { category: string; items: Sector[] }[] {
  const order: string[] = [];
  const map = new Map<string, Sector[]>();
  for (const sector of sectors) {
    const category =
      sector.category?.name ?? t("questionnaire.identification.otherSectors");
    if (!map.has(category)) {
      map.set(category, []);
      order.push(category);
    }
    map.get(category)!.push(sector);
  }
  return order.map((category) => ({ category, items: map.get(category)! }));
}
